import { Component, forwardRef } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { Observable } from 'rxjs';
import { ListResult } from '../../../api/core/list-result';
import { LookupItem } from '../../../api/data-model';
import { LookupService } from '../../../services/service';
import { BasePickerComponent } from './base-picker.component';

@Component({
  selector: 'app-process-template-version-picker',
  standalone: true,
  imports: [
    FormsModule,
    AutoCompleteModule
  ],
  templateUrl: './base-picker.component.html',
  providers: [
    LookupService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProcessTemplateVersionPickerComponent),
      multi: true
    }
  ]
})
export class ProcessTemplateVersionPickerComponent extends BasePickerComponent<LookupItem> {
  constructor(private readonly lookupService: LookupService) {
    super();
  }

 override search(query: string): Observable<ListResult<LookupItem>> {
    return this.lookupService.getProcessTemplateVersions(undefined, query, 20);
  }

  override load(keys: string[]): Observable<ListResult<any>> {
    return this.lookupService.getProcessTemplateVersions(keys);
  }
}
